import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import AccessRequest from './components/Register';
import Dashboard from './components/Dashboard';
import AdminPanel from './components/AdminPanel';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(null);
  const [branding, setBranding] = useState({
    company_name: 'Health & Safety Platform',
    primary_color: '#4a90e2',
    secondary_color: '#1a1a1a',
    logo_url: null
  });

  useEffect(() => {
    fetchBranding();
    if (token) {
      fetchUserProfile();
    }
  }, [token]);

  const fetchBranding = async () => {
    try {
      const response = await fetch('/api/branding');
      if (response.ok) {
        const brandingData = await response.json();
        setBranding(brandingData);
        
        // Apply colors to CSS variables
        document.documentElement.style.setProperty('--primary-color', brandingData.primary_color);
        document.documentElement.style.setProperty('--secondary-color', brandingData.secondary_color);
      }
    } catch (error) {
      console.error('Error fetching branding:', error);
    }
  };

  const fetchUserProfile = async () => {
    try {
      const response = await fetch('/api/profile', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const userData = await response.json();
        setUser(userData);
      } else {
        handleLogout();
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
      handleLogout();
    }
  };

  const handleLogin = (newToken, userData) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={token ? <Navigate to="/" /> : <Login onLogin={handleLogin} branding={branding} />} 
        />
        <Route 
          path="/request-access" 
          element={token ? <Navigate to="/" /> : <AccessRequest branding={branding} />} 
        />
        <Route 
          path="/" 
          element={
            token && user ? (
              user.isAdmin ? (
                <AdminPanel user={user} onLogout={handleLogout} token={token} branding={branding} refreshBranding={fetchBranding} />
              ) : (
                <Dashboard user={user} onLogout={handleLogout} token={token} branding={branding} />
              )
            ) : (
              <Navigate to="/login" />
            )
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;
